import { render, staticRenderFns } from "./ProductHomePage.vue?vue&type=template&id=5047aa63&"
import script from "./ProductHomePage.vue?vue&type=script&lang=js&"
export * from "./ProductHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports